<template>
    <div class="container-fluid">
        <notifications group="msg" class="stacked-messages-wrapper" position="bottom right"/>
        <notifications group="app-baxolash">
          <template slot="body" slot-scope="props">
            <div class="custom-notification-wrapper">
              <div class="custom-notification-icon">
                <i class="fa fa-exclamation-circle"/>
              </div>
              <div class="custom-notification-title" v-html="props.item.title"></div>
              <div class="custom-notification-content" v-html="props.item.text">
              </div>
              <div class="d-flex align-items-center justify-content-center">
                <button class="all-btn btn-sm delete-btn mr-1" @click="onReject(props.item.data, props.close)">
                  Бекор қилиш
                </button>
                <button class="all-btn btn-sm dark-btn ml-1" @click="props.close">
                  Ойнани ёпиш
                </button>
              </div>
            </div>
          </template>
        </notifications>
        <notifications group="jenkins-notification" position="top center">
          <template slot="body" slot-scope="props">
            <div class="custom-notification-wrapper">
              <div class="custom-notification-title d-flex align-items-center justify-content-center">
                <BaseTimerView :timeLimit="props.item.data.timeout" v-if="props.item.data.timeout > 10"></BaseTimerView>
              </div>
              <div class="custom-notification-content color-black" v-html="props.item.text"></div>
            </div>
          </template>
        </notifications>
        <notifications group="base-notification-notify">
          <template slot="body" slot-scope="props">
            <div class="custom-notification-wrapper base-notification-notify">
              <div class="custom-notification-content" v-html="props.item.data.text"></div>
              <button class="btn bg-transparent border-0 position-absolute text-danger p-1" style="top: -0.2rem; right: 0;" @click="props.close">
                <i class="fa fa-close"></i>
              </button>
            </div>
          </template>
        </notifications>
    </div>
</template>

<script>
    import SockJS from 'sockjs-client'
    import Stomp from 'webstomp-client'
    import Cookies from "js-cookie";
    import BaseTimerView from "@/views/common/BaseTimerView.vue";
    import {mapState} from "vuex";
    import {getArchiveModeDetailsByVersion} from "@/shared/archive-mode-utils";

    export default {
        name: "WebSocketConfig",
        components: {BaseTimerView},
        data() {
            return {
                send_message: null,
                connected: false,
                reconnectAttempts: 0,
                maxReconnectAttempts: 200, // Limit retries
                reconnectDelay: 1000, // each second delay before retry,
                subscriptionsAfterAuthorization: {}
            }
        },
        methods: {
            send() {
                if (this.stompClient && this.stompClient.connected) {
                    const msg = { name: this.send_message };
                    this.stompClient.send('/app/from-client', JSON.stringify(msg), {})
                }
            },
            connect() {
                this.socket = new SockJS(getArchiveModeDetailsByVersion(Cookies.get('archive_version')).url + 'v2/websocket-endpoint');
                this.stompClient =  Stomp.over(this.socket);
                this.stompClient.connect({},
                    (frame) => {
                        this.connected = true;
                        console.log('Connected: ' + frame);

                        this.stompClient.subscribe('/topic/jenkins-notify', (message) => {
                          this.onProjectUpdate(JSON.parse(message.body));
                        });

                        this.toggleSubscriptionsAfterAuthorization()

                    }, (error) => {
                        console.log(error);
                        this.connected = false
                        this.handleReconnect()
                    })
            },
            toggleSubscriptionsAfterAuthorization() {
              if(this.stompClient && this.stompClient.connected) {
                if(this.$store.state.profile && this.$store.state.profile.usernameMd5Hash) {

                  this.subscribeToAuthTopic('topic/app.baxolash.uz', (message) => {
                    this.onMessage(JSON.parse(message.body));
                  })

                  this.subscribeToAuthTopic('topic/real-time-report', () => {
                    this.onChangesRealTimeReport();
                  })

                  this.subscribeToAuthTopic('topic/app.baxolash.uz/real-estate/android', (message) => {
                    this.onChangeReceiveForRealEstateDataFromAndroid(JSON.parse(message.body));
                  })

                  this.subscribeToAuthTopic('topic/app.baxolash.uz/auto/android', (message) => {
                    this.onChangeReceiveForAutoFromAndroid(JSON.parse(message.body));
                  })

                  this.subscribeToAuthTopic('topic/app.baxolash.uz/auto-loses/android', (message) => {
                    this.onChangeReceiveForAutoLosesFromAndroid(JSON.parse(message.body));
                  })

                  this.subscribeToAuthTopic('topic/notification-notify', (message) => {
                    this.onNotificationNotify(JSON.parse(message.body));
                  })

                } else {
                  Object.keys(this.subscriptionsAfterAuthorization).forEach(subscriptionKey => {
                    this.subscriptionsAfterAuthorization[subscriptionKey].unsubscribe();
                    delete this.subscriptionsAfterAuthorization[subscriptionKey];
                  })
                }
              }
            },
            subscribeToAuthTopic(topicName, callback = () => {}) {
              if(!this.subscriptionsAfterAuthorization.hasOwnProperty(topicName)) {
                this.subscriptionsAfterAuthorization[topicName] = this.stompClient.subscribe(`/${topicName}/${this.$store.state.profile.usernameMd5Hash}`, callback);
              }
            },
            disconnect() {
                if (this.stompClient) {
                    this.stompClient.disconnect()
                    this.subscriptionsAfterAuthorization = {}
                }
                console.log("Disconnected");
                this.connected = false
            },
            tickleConnection() {
                this.connected ? this.disconnect() : this.connect();
            },
            handleReconnect() {
              if (this.reconnectAttempts < this.maxReconnectAttempts) {
                this.subscriptionsAfterAuthorization = {}
                this.reconnectAttempts++;
                setTimeout(() => this.connect(), this.reconnectDelay);
              } else {
                console.error("❌ Max reconnect attempts reached. Stopping retries.");
              }
            },
            unsubscribeSessions() {
              if(this.socket) {
                this.socket.close()
                this.socket = null
                this.subscriptionsAfterAuthorization = {}
              }
            },
            onMessage(message) {
                let actionToContent
                if (message.content && message.content.constructor === Object) {
                  actionToContent = JSON.parse(message.content)
                }

                if (actionToContent && actionToContent.action === 'Rejected') {
                    this.$notify({
                      group: 'app-baxolash',
                      title:  message.title,
                      text: actionToContent.comment,
                      type: 'info',
                      speed: 300,
                      duration: -100,
                      data: actionToContent
                    });
                } else {
                    let option = {
                        group: 'msg',
                        title: message.title,
                        text: message.content,
                        type: 'success',
                        speed: 2000,
                        data: message.content
                    };
                    if (message.duration) {
                        option.duration = message.duration;
                    }
                    this.$notify(option);
                }
            },
            onChangesRealTimeReport() {
                this.$eventBus.$emit("realReportUpdate")
            },
            onChangeReceiveForRealEstateDataFromAndroid(message) {
                const routeName = this.$route.name
                if (message.content && ('new-real-estate-notorious-new' === routeName || 'new-real-estate-residential-new' === routeName || 'new-comparative' === routeName)) {
                    let content = JSON.parse(message.content);
                    if (content.evlType === 'REAL_ESTATE') {
                        this.$eventBus.$emit("receiveForRealEstateDataFromAndroid", content)
                    } else if (content.evlType === 'REAL_TIME') {
                        this.$eventBus.$emit("receiveForRealTimeDataFromAndroid", content)
                    }
                }
            },
            onChangeReceiveForAutoFromAndroid(message) {
                const routeName = this.$route.name
                if (message.content && (('auto-new' === routeName) || ('auto-edit' === routeName))) {
                    let content = JSON.parse(message.content);
                    this.$eventBus.$emit("receiveForAutoDataFromAndroid", content)
                }
            },
            onChangeReceiveForAutoLosesFromAndroid(message) {
                const routeName = this.$route.name
                if (message.content && (('auto-loses-new' === routeName) || ('auto-loses-edit' === routeName))) {
                    let content = JSON.parse(message.content);
                    this.$eventBus.$emit("receiveForAutoLosesDataFromAndroid", content)
                }
            },
            onReject(content, closeFn) {
              if(typeof closeFn === 'function') {
                closeFn()
              }
              let dataStatus = {}
              dataStatus.status = 'AssignedToEvaluator'

              let rejectData = {}

              let urlStatus = ''
              let rejectUrl = ''

              const id = content.id

              if (content.objectType === 'BUILDING') {
                dataStatus.realEstateId = id

                rejectData.realEstateId = id
                rejectData.reasonDesc = content.comment
                rejectData.status = 'Rejected'

                urlStatus = 'admin/new-real-estate/status'
                rejectUrl = 'admin/new-real-estate/status/reject'

              } else if (content.objectType === 'EXPERT2') {
                dataStatus.objectId = id

                rejectData.rejectObjectId = id
                rejectData.comment = content.comment

                urlStatus = 'admin/expert2/status'
                rejectUrl = 'expert2/common/reject'
              }

              if (urlStatus.length && rejectUrl.length) {
                if (content.status === 'AssignedToEvaluator') {
                  this.rejectObject(rejectUrl, rejectData)

                } else if (content.status === 'NotFullyEvaluated') {
                  this.$http.post(urlStatus, dataStatus)
                      .then(res => {
                        if (res && res.data && res.data.status === 'SUCCESS') {
                          this.rejectObject(rejectUrl, rejectData)
                        }
                      }, () => {
                        this.$swal({
                          title: this.$root.$t('messages.common.error'),
                          text: this.$root.$t('messages.realEstate.statusError'),
                          type: 'error'
                        });
                      });
                }
              }
            },
            rejectObject(rejectUrl, data) {
                const vm = this
                this.$http.post(rejectUrl, data).then(function (res) {
                    if (res && res.data && res.data.status === 'SUCCESS') {
                        vm.$router.go(1)
                    }
                }, () => {
                });
            },
            onProjectUpdate(message) {
              this.$notify({
                group: 'jenkins-notification',
                type: 'success',
                speed: 100,
                data: message,
                text: message.text,
                duration: message.timeout * 1000
              });
            },
            onNotificationNotify(message) {
              this.$notify({
                group: 'base-notification-notify',
                type: 'success',
                speed: 100,
                data: message,
                duration: message.timeout * 1000
              });
            }
        },
        created() {
            this.tickleConnection();
        },
        mounted() {
            // this.tickleConnection();
        },
        beforeDestroy() {
          this.unsubscribeSessions()
        },
        destroyed() {
            // this.unsubscribeSessions();
        },
        computed: {
          ...mapState(['profile', 'archiveModeVersion'])
        },
        watch: {
          profile: {
            handler: function() {
              this.toggleSubscriptionsAfterAuthorization()
            },
            deep: true
          },
          archiveModeVersion: {
            handler: function() {
              if(this.connected) {
                this.disconnect();
                setTimeout(() => {
                  this.connect();
                }, 500)
              }
            },
            deep: true
          }
        }
    }
</script>

<style scoped>

</style>